import { Text, useDevice } from '@lune-fe/lune-ui-lib'
import { Box } from '@mui/material'
import Image from 'next/image'
import { useRouter } from 'next/navigation'
import { FC } from 'react'

const NavigationTile: FC<{
    backgroundImageUrl: string
    title: string
    href: string
    gradientColor: string
}> = ({ backgroundImageUrl, title, href, gradientColor }) => {
    const { smScreen, mdScreen } = useDevice()
    const router = useRouter()
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                flexDirection: 'column',
                height: { xs: '328px', lg: '466px' },
                width: '100%',
                position: 'relative',
                overflow: 'hidden',
                borderRadius: '32px',
                img: {
                    position: 'absolute',
                    bottom: 0,
                    width: smScreen ? '100%' : 'auto',
                    height: smScreen ? 'auto' : '100%',
                    zIndex: -1,
                    margin: 'auto',
                    transition: 'transform 0.3s ease',
                },
                '&:hover img': {
                    transform: 'scale(1.05)',
                },
                cursor: 'pointer',
            }}
            onClick={() => {
                router.push(href)
            }}
        >
            <Image src={backgroundImageUrl} width={466} height={466} alt={`${title}-image`} />
            <Box
                sx={{
                    height: '200px',
                    width: '100%',
                    background: `linear-gradient(to top, ${gradientColor} 0px, transparent 200px)`,
                }}
            />
            <Box
                sx={{
                    height: '50px',
                    width: '100%',
                    backgroundColor: gradientColor,
                }}
            />
            <Box
                sx={{
                    position: 'absolute',
                    pb: 3,
                    pr: 3,
                    pl: 3,
                }}
            >
                <Text variant={mdScreen ? `h6` : `h5`} color={'White'}>
                    {title}
                </Text>
            </Box>
        </Box>
    )
}

const CaseStudySummary: FC = () => {
    const { smScreen, mdScreen } = useDevice()
    return (
        <Box
            sx={{
                display: 'flex',
                gap: smScreen ? 3 : mdScreen ? 2 : 3,
                flexDirection: smScreen ? 'column' : 'row',
            }}
        >
            <NavigationTile
                backgroundImageUrl={'/images/compressed-case-study/forto.png'}
                title={
                    'Read about how Forto built a sustainable competitive advantage using emissions intelligence'
                }
                href={'/customers/forto'}
                gradientColor="#0A143C"
            />
            <NavigationTile
                backgroundImageUrl={'/images/compressed-case-study/logixboard.png'}
                title={
                    'Read about how freight forwarders are winning tenders using Logixboard’s CO2 reporting tool'
                }
                href={'/customers/logixboard'}
                gradientColor="#02141D"
            />
            <NavigationTile
                backgroundImageUrl={'/images/compressed-case-study/payhawk.png'}
                title={
                    'Read about how 200+ customers are unraveling scope 3 emissions using Payhawk Green'
                }
                href={'/customers/payhawk'}
                gradientColor="#143230"
            />
        </Box>
    )
}

export default CaseStudySummary
